import React, { Component } from 'react';
import axios from 'axios';
import { API_HOST } from '../../consts';
import { get } from 'lodash-es';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { toast } from 'react-toastify';
import { withTheme } from 'styled-components';
import RawInputSummernote from '../../components/inputs/RawInputSummernote';
import ReactJson from 'react-json-view';
import html2pdf from 'html2pdf.js';

class GPTResponse extends Component {
  state = {
    loading: false,
    apiResponseValues: '',
    apiResponseOptions: [],
    htmlApiResponse: null,
    promptResponse: null,
    isOpen: false,
    isLoading: false,
    area_conhecimento: {},
    escola: {},
    livro: {},
    capitulo: {},
    turma: {},
    periodo: {},
    habilidade: {},
    edited_html_content: null
  };

  handleFilterChange = (filters) => {
    this.props.onFilterChange(filters);
  };

  id() {
    return get(this.props, 'match.params.id');
  }

  handleUpdateHtml() {
    let id = this.id();
    const { edited_html_content } = this.state;

    if (!edited_html_content) {
      toast.error('Preencha o campo para prosseguir com está ação.');
    }
    if (id && edited_html_content) {
      axios
        .post(`${API_HOST}/openai/api-response/${id}/edit_html`, {
          html: edited_html_content
        })
        .then((response) => {
          toast.success('Alterações salvar com sucesso.');
        })
        .catch((error) => {
          console.error(error);
          toast.error('Ocorreu um erro, Tente novamente.');
        });
    }
  }

  fetchApiResponse() {
    let id = this.id();
    if (id) {
      axios
        .get(`${API_HOST}/openai/api-response/${id}`)
        .then((response) => {
          if (response.data.api_response_status === 200) {
            const apiValuesParsed = JSON.parse(
              get(response.data, 'form_api_values', '')
                .replace(/'/g, '"')
                .replace('False', 'false')
                .replace('None', 'null')
            )[1];
            this.setState({
              promptResponse: get(response.data, 'prompt.messages', ''),
              apiResponseOptions: response.data,
              htmlApiResponse: response.data.formated_api_response,
              apiResponseValues: apiValuesParsed,
              edited_html_content: response.data.formated_api_response
            });
            this.fetchAreaConhecimento(get(apiValuesParsed, 'form.values'));
            this.fetchLivro(get(apiValuesParsed, 'form.values'));
            this.fetchCapitulo(get(apiValuesParsed, 'form.values'));
            this.fetchEscola(get(apiValuesParsed, 'form.values'));
            this.fetchNivel(get(apiValuesParsed, 'form.values'));
            this.fetchTurma(get(apiValuesParsed, 'form.values'));
            this.fetchHabilidade(get(apiValuesParsed, 'form.values'));
            this.fetchJsonPrompt();
          } else {
            this.setState({
              apiResponseOptions: response.data
            });
            toast.error('Ocorreu um erro, tente novamente.');
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      toast.error('resultado não encontrado, tente novamente!');
    }
  }

  onSummernoteChange(value) {
    this.setState({
      edited_html_content: value
    });
  }

  fetchEscola(value) {
    const escola = get(value, 'Escolas');
    const municipio = get(value, 'Municipios');
    const params = {
      cd_municipio: municipio,
      cd_escola: escola
    };
    axios
      .get(`${API_HOST}/avalia/escola`, { params })
      .then((response) => {
        this.setState({
          escola: get(response, 'data[0]')
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  fetchAreaConhecimento(value) {
    const areaConhecimento = get(value, 'area_conhecimento');

    axios
      .get(`${API_HOST}/core/area_conhecimento?id=${areaConhecimento}`)
      .then((response) => {
        this.setState({
          area_conhecimento: get(response, 'data[0]')
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  fetchLivro(value) {
    const livro = get(value, 'livro');
    const areaConhecimento = get(value, 'area_conhecimento');
    const params = {
      area_conhecimento_id: areaConhecimento,
      id: livro
    };
    axios
      .get(`${API_HOST}/openai/livro`, { params })
      .then((response) => {
        this.setState({
          livro: get(response, 'data[0]')
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }
  fetchCapitulo(value) {
    const livro = get(value, 'livro');
    const capitulo = get(value, 'capitulo');
    const params = {
      id_livro: livro,
      id: capitulo
    };
    axios
      .get(`${API_HOST}/openai/capitulo`, { params })
      .then((response) => {
        this.setState({
          capitulo: get(response, 'data[0]')
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  fetchNivel = (value) => {
    const periodo = get(value, 'periodo');

    axios
      .get(`${API_HOST}/core/periodo/${periodo}`)
      .then((response) => {
        this.setState({
          periodo: get(response, 'data')
        });
      })
      .catch((err) => console.error(err));
  };
  fetchTurma(value) {
    const turma = get(value, 'turma');
    const params = {
      cd_turma: turma
    };
    axios
      .get(`${API_HOST}/avalia/turma`, { params })
      .then((response) => {
        this.setState({
          turma: get(response.data, 'results[0]')
        });
      })
      .catch((err) => console.error(err));
  }
  fetchHabilidade(value) {
    const habilidade = get(value, 'habilidade');

    axios
      .get(`${API_HOST}/matriz_referencia/habilidade?id=${habilidade}`)
      .then((response) => {
        const options = response.data.results.map((mapResponse) => ({
          value: mapResponse.id,
          label: `${mapResponse.cd_habilidade} - ${mapResponse.ds_habilidade}`
        }));
        this.setState({ habilidade: options[0] });
      });
  }

  convertMinutesToHour(value) {
    var hour = Math.floor(value / 60);
    var minutes = value % 60;

    var hourString = hour.toString().padStart(2, '0');
    var minutosString = minutes.toString().padStart(2, '0');

    return hourString + 'hrs e ' + minutosString + 'minutos';
  }

  toggle = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
    this.setState({
      toggleHelp: !this.state.toggleHelp
    });
  };
  componentDidMount() {
    this.fetchApiResponse();
  }

  handleConvertToPDF = () => {
    const element = document.createElement('div');
    const mockHtml = this.state.htmlApiResponse;
    element.innerHTML = mockHtml;

    const opt = {
      margin: 10,
      filename: element.getElementsByTagName('title')[0].innerText + '.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };

    html2pdf().from(element).set(opt).save();
  };

  render() {
    const {
      apiResponseValues,
      htmlApiResponse,
      area_conhecimento,
      livro,
      capitulo,
      escola,
      periodo,
      turma,
      habilidade,
      isOpen,
      promptResponse
    } = this.state;
    const dataResponse = get(apiResponseValues, 'form.values');
    const primaryColor = this.props.theme.primary;
    const duracaoAula = get(dataResponse, 'duracao_aula');
    const showTab = true;

    if (showTab) {
      return (
        <div className="container mb-4 pb-4" style={{ marginTop: '60px' }}>
          <div
            className="card-header"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              fontWeight: 700,
              backgroundColor: '#F0F0F0',
              borderRadius: '10px',
              boxShadow: '2px 2px 7px rgba(0, 0, 0, 0.09)'
            }}
          >
            <h1>Sugestão Pedagógica</h1>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-around'
              }}
            >
              <button
                style={{
                  border: 'none',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  borderRadius: '20px',
                  boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                  padding: '4px 16px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginRight: '20px',
                  color: this.props.theme.textButton,
                  background: primaryColor
                }}
                onClick={() => this.handleConvertToPDF()}
              >
                Imprimir
              </button>
              <i
                className="fas fa-question-circle"
                onClick={() => this.setState({ isOpen: !isOpen })}
                style={{ fontSize: '20px', verticalAlign: 'middle' }}
              />
            </div>
          </div>
          <div
            style={{
              marginTop: '30px',
              border: '1px solid #ccc',
              padding: '0.9rem',
              borderRadius: '12px'
            }}
          >
            <div className="row">
              <div className="input-type-style row">
                <div className="col-md-12" style={{ marginTop: '3.5rem' }}>
                  <div className="col-md-12 gpt-content">
                    <span className="gpt-span" style={{ color: primaryColor }}>
                      {get(escola, 'nm_escola')}
                    </span>
                  </div>
                  <div className="col-md-12 gpt-content">
                    <span className="gpt-span" style={{ color: primaryColor }}>
                      {get(periodo, 'descricao')} - {get(turma, 'nm_turma')}
                    </span>
                  </div>
                  <div className="col-md-12 gpt-content">
                    <span className="gpt-span" style={{ color: primaryColor }}>
                      {get(area_conhecimento, 'descricao')}
                    </span>
                  </div>
                  {get(dataResponse, 'livro', 'capitulo') ? (
                    <div className="col-md-12 gpt-content">
                      <span
                        className="gpt-span"
                        style={{ color: primaryColor }}
                      >
                        Livro {get(dataResponse, 'livro')} -{' '}
                        {get(livro, 'titulo')} , Capítulo{' '}
                        {get(dataResponse, 'capitulo')} -{' '}
                        {get(capitulo, 'nome')}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                  {duracaoAula ? (
                    <div className="col-md-12 gpt-content">
                      <span style={{ fontSize: '1.3rem', color: primaryColor }}>
                        Duração total estimada: {duracaoAula}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
                <div className="col-md-1">
                  {get(dataResponse, 'link_capa') && (
                    <img
                      src={get(dataResponse, 'link_capa')}
                      style={{ borderRadius: '12px' }}
                      alt="image-book"
                      width="180px"
                    />
                  )}
                </div>
              </div>
              <div className="container" style={{ marginTop: '50px' }}>
                <div
                  className="card-header"
                  style={{
                    fontSize: '18px',
                    fontWeight: 600,
                    backgroundColor: '#F2F2F2',
                    borderRadius: '10px',
                    boxShadow: '2px 2px 7px rgba(0, 0, 0, 0.09)'
                  }}
                >
                  <div
                    className="row gpt-collapse"
                    style={{
                      color: primaryColor
                    }}
                  >
                    <div className="col-md-12">
                      <span>Objetivos de aprendizagem:</span>
                    </div>
                    <div
                      className="col-md-12 gpt-card"
                      style={{ marginTop: '20px' }}
                    >
                      <span style={{ textAlign: 'center' }}>
                        Habilidades da Educação Básica
                      </span>
                      <div
                        className="col-md-12 gpt-card mt-3"
                        style={{ borderColor: primaryColor }}
                      >
                        <span>{get(habilidade, 'label')}</span>
                      </div>
                    </div>
                    <div
                      className="col-md-6 gpt-card"
                      style={{ marginTop: '20px' }}
                    >
                      <span style={{ textAlign: 'center' }}>
                        Habilidades da Educação Tecnológica
                      </span>
                      <div
                        className="col-md-12 gpt-card mt-3"
                        style={{ borderColor: '#8C8C8C' }}
                      >
                        <span style={{ textAlign: 'center', color: '#8C8C8C' }}>
                          Habilidade de educação tecnológica não selecionada
                        </span>
                      </div>
                    </div>

                    <div
                      className="col-md-6 gpt-card"
                      style={{ marginTop: '20px' }}
                    >
                      <span style={{ textAlign: 'center' }}>
                        Habilidades Socioemocionais
                      </span>
                      <div
                        className="col-md-12 gpt-card mt-3"
                        style={{ borderColor: '#8C8C8C' }}
                      >
                        <span style={{ textAlign: 'center', color: '#8C8C8C' }}>
                          Habilidade socioemocional não selecionada
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-12"
                style={{ marginTop: '50px', width: '100%' }}
              >
                <RawInputSummernote
                  value={htmlApiResponse}
                  onChange={(event) => this.onSummernoteChange(event)}
                />
              </div>
              <div
                className="col-md-12"
                style={{
                  marginTop: '1rem',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <button
                  style={{
                    border: 'none',
                    fontSize: '1rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    borderRadius: '20px',
                    boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                    padding: '4px 16px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginLeft: '1rem',
                    color: this.props.theme.textButton,
                    background: this.props.theme.secondary
                  }}
                  onClick={() => this.handleUpdateHtml()}
                >
                  Salvar alterações
                </button>
              </div>
            </div>
            <Modal
              style={{ marginTop: '500px' }}
              size="lg"
              isOpen={isOpen}
              toggle={this.toggle}
            >
              <ModalHeader toggle={this.toggle}>
                Conteudo da Solicitação
              </ModalHeader>
              <ModalBody style={{ padding: '1.5rem' }}>
                <pre id="json-data">
                  <ReactJson enableClipboard={false} src={promptResponse} />
                </pre>
              </ModalBody>
              <ModalFooter>
                <button
                  className="btn primary-button mr-3"
                  type="button"
                  onClick={this.toggle}
                >
                  OK
                </button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      );
    }
  }
}

export default withTheme(GPTResponse);
